module.exports = __webpack_public_path__ + "media/subway/7-c8a52c31.png";